import { IntlShape } from 'react-intl';

import { mapBipsToObsDeposits } from './deposits';
import { mapBipsToObsCountries } from './countries';
import { mapBipsToObsPartnerBank } from './partner_banks';
import { Country, Deposit, Offers, PartnerBankElement } from '../../types';

/**
 * Transforms OffersData response into OBS-like structure.
 *
 * @param data BIPSified response from DBS.
 * @returns OBS structured response.
 */
export const transformOffersDataResponse = (
  bipsData,
  formatNumber: IntlShape['formatNumber'],
  t,
  formatDate: IntlShape['formatDate'],
  locale: IntlShape['locale'],
): Offers => {
  const partnerBanks = new Map<string, PartnerBankElement>();
  const countries = new Map<string, Country>();
  const deposits = new Map<string, Deposit>();

  for (let i = 0; i < bipsData?.entries?.length; i++) {
    const product = bipsData.entries[i];
    const bankId = product?.deposit_taking_bank?.id;
    const depositId = product?.id;
    const countryId = product?.deposit_taking_bank?.branch_country?.unique_country_id;
    try {
      if (!!depositId && !deposits.has(depositId)) {
        deposits.set(depositId, mapBipsToObsDeposits(product, formatNumber, t, formatDate, locale));
      }

      if (!!countryId && !countries.has(countryId)) {
        countries.set(countryId, mapBipsToObsCountries(product));
      }

      if (!!bankId && !partnerBanks.has(bankId)) {
        partnerBanks.set(bankId, mapBipsToObsPartnerBank(product, t, { formatNumber, formatDate }));
      }
    } catch (error) {
      console.info(depositId, error);
    }
  }

  return {
    countries: Array.from(countries.values()),
    partner_banks: Array.from(partnerBanks.values()),
    deposits: Array.from(deposits.values()),
  };
};
